"use client";

import { useEffect } from "react";
import {
  identifyUser,
  type OrganizationGroupIdentification,
} from "@/lib/posthog-identify";

type PostHogIdentifyClientProps = {
  user: {
    id: string;
    email: string;
    fullName?: string;
  };
  organization: OrganizationGroupIdentification;
};

export function PostHogIdentifyClient({
  user,
  organization,
}: PostHogIdentifyClientProps) {
  const { id, name, plan, createdAt, memberCount } = organization;

  useEffect(() => {
    identifyUser({
      id: user.id,
      email: user.email,
      fullName: user.fullName,
      organization: { id, name, plan, createdAt, memberCount },
    });
  }, [
    user.id,
    user.email,
    user.fullName,
    id,
    name,
    plan,
    createdAt,
    memberCount,
  ]);

  return null;
}
